import { getCustomerByHostname } from '../config/customers';

export function getCustomerFromCurrentHostname() {
  if (typeof window === 'undefined') {
    return null;
  }

  const hostname = window.location.hostname.toLowerCase();
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return null;
  }

  return getCustomerByHostname(hostname);
}
